import { useNavigate } from "react-router-dom";
import { navigation } from "../../constante/navigation";

interface Props {
    children: React.ReactElement;
}

export default function CustomNavigation(props: Props){
    navigation.navigate = useNavigate();

    return (props.children);
}